import React, { useEffect, useState, useRef } from 'react';
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  LinearProgress,
  Paper,
  Typography,
} from '@mui/material';
import { useStore } from '../../../utils/store';
import TextFieldComponent from '../../../components/form/TextFieldComponent';
import Grid from '@mui/material/Grid2';
import {
  currentDatePlusDate,
  getCurrentDate,
  handleErrorMessage,
} from '../../../utils/storageUtil';
import SelectFieldComponent from '../../../components/form/SelectFieldComponent';
import DatePickerComponent from '../../../components/DatePickerComponent';
import IconItem from './iconItem';
import IdLabelData from '../../../Models/IdLabelData';
import TextFieldAreaComponent from '../../../components/form/TextFieldAreaComponent';
import { Refresh } from '@mui/icons-material';
import Constants from '../../../utils/constants';
import HttpServices from '../../../services/HttpService';
import AlertMessageComponent from '../../../components/AlertMessageComponent';
import { useAlert } from '../../../components/alertContext';
interface SWMSDetailsProps {
  projectInternalId: number;
}
const SWMSDetails: React.FC<SWMSDetailsProps> = ({ projectInternalId }) => {
  const dropDownValues: IdLabelData[] = [
    { id: '', label: ' ' },
    { id: 'All Workers', label: 'All Workers' },
    { id: 'Compliance Officer', label: 'Compliance Officer' },
    { id: 'Principal Contractor', label: 'Principal Contractor' },
    {
      id: 'Principal Contractor & Supervisor',
      label: 'Principal Contractor & Supervisor',
    },
    { id: 'Supervisor', label: 'Supervisor' },
    {
      id: 'Supervisor & WHS Representative',
      label: 'Supervisor & WHS Representative',
    },
    {
      id: 'Supervisor and/or Compliance Officer',
      label: 'Supervisor and/or Compliance Officer',
    },
    { id: 'Supervisors & All Workers', label: 'Supervisors & All Workers' },
    { id: 'WHS Representative', label: 'WHS Representative' },
  ];
  const isInitialLoad = useRef(true);
  const [usersList, setUsersList] = useState<IdLabelData[]>([]);
  const { alert, setAlert, handleCloseAlert } = useAlert();
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { getAdmin } = useStore();
  const [form, setForm] = useState({
    workActivity: '',
    siteOwner: '',
    developedBy: '',
    approvedBy: '',
    datePrepared: getCurrentDate(),
    revisionDate: currentDatePlusDate(0, 1, 0),
  });
  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      if (usersList.length === 0) fetchUsers();
    }
    fetchSingleRecord();
  }, [projectInternalId]);
  const fetchUsers = async () => {
    try {
      const URL = `${Constants.apiURL}${Constants.usersURL}`;
      const response = await HttpServices.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { active: '1', limit: -1 }
      );
      if (response.data) {
        // console.log('users-name');
        // console.log(response.data);
        // console.log('users-name');
        setUsersList([
          { id: '', label: '' },
          ...response.data.paginateRecords
            .map((item: any) => ({
              id: item.id,
              label: item.firstName + ' ' + item.lastName,
            }))
            .sort((a: any, b: any) => a.label.localeCompare(b.label)),
        ]);
      }

      // console.log('GET Response:', response);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const fetchSingleRecord = async () => {
    try {
      setIsLoading(true);
      const URL = `${Constants.apiURL + Constants.projectDashboardsURL}/${projectInternalId}/swmsdetails`;
      const response = await HttpServices.get(
        URL,
        { headers: { Authorization: 'Bearer ' + getAdmin() } },
        { active: '1' }
      );
      setIsLoading(false);
      if (response.data) {
        handleRowClick(response.data);
      }

      // console.log('GET Response:', response);
    } catch (error) {
      setIsLoading(false);
      console.error('Error fetching data:', error);
    }
  };

  const hazardousWorkItems = [
    'Electrical equipment',
    'Elevated levels',
    'Slips, trips, and falls',
    'Hazardous substances',
    'Working from heights',
    'Hot Work',
    'Hazardous manual tasks',
    'Outdoor work',
    'Remotely &/or isolated work',
    'Plant or machinery hazards',
    'Noise and vibration',
    'Native vegetation & weeds',
    'Air quality',
    'Waste',
    'Vehicle movement',
    'Fuels, oils & chemicals',
    'Terrestrial fauna',
    'Waterways & soils',
    'Cultural heritage',
    'Working near the public',
  ];
  const [selectedhazardousWorkItems, setSelectedhazardousWorkItems] = useState<
    any[]
  >([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);
  const highRiskConstructionWorkItems = [
    'Confined spaces',
    'Mobile plant movement',
    'Demolition of a load-bearing structure',
    'Asbestos disturbance',
    'Using explosives',
    'Diving work',
    'Artificial extremes of temperature',
    'Tilt-up or pre-cast concrete',
    'Pressurised gas distribution mains or piping chemical, fuel, or refrigerant lines energised electrical installations or services',
    'Structures or buildings involving structural alterations or repairs that require temporary support to prevent collapse',
    'Involves a risk of a person falling from 2m or more, including work on telecommunications towers',
    'Working at depths greater than 1.5 Metres, including tunnels or mines',
    'Work in an area that may have a contaminated or flammable atmosphere',
    'Work carried out adjacent to a road, railway or shipping lane, traffic corridor',
    'In or near water or other liquid that involves the risk of drowning',
  ];
  const [
    selectedhighRiskConstructionWorkItems,
    setSelectedhighRiskConstructionWorkItems,
  ] = useState<any[]>([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);
  const ppeItems = [
    'Foot Protection',
    'Hearing Protection',
    'High Visibility',
    'Head Protection',
    'Eye Protection',
    'Face Protection',
    'Hand Protection',
    'Protective Clothing',
    'Breathing Protection',
    'Sun Protection',
    'Safety Harness',
    'Rings, watches, jewellery restriction',
  ];
  const [selectedPPEItems, setSelectedPPEItems] = useState<any[]>([
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
    '0',
  ]);
  const [inProgress, setInProgress] = useState<boolean>(false);
  const planningPreparationItems = [
    'Liaise with Principal Contractor to identify on-site safety systems and procedures',
    'Establish supervisory and communication arrangements',
    'Principal contractor to confirm emergency response procedures are in place',
    'All Subcontractor and workers must follow PC Implemented emergency and response procedures described during site induction',
  ];

  const [selectedPlanning, setSelectedPlanning] = useState<any[]>([
    '',
    '',
    '',
    '',
  ]);
  const holdPointsItems = [
    'Hold points identified and signed off before continuing work',
  ];

  const [selectedHoldPointsItems, setSelectedHoldPointsItems] = useState<any[]>(
    ['']
  );
  const trainingLicenceItems = [
    'All workers to have a General Construction Induction Card',
    'Relevant workers have relevant certificates of competency, licenses, and training',
    'Trained First Aider on site',
    'All workers are trained in site-specific emergency and evacuation procedures, SWMS, safe work procedures, and safety data sheets',
  ];

  const [selectedTrainingLicenceItems, setSelectedTrainingLicenceItems] =
    useState<any[]>(['', '', '', '']);
  const workerDutiesItems = [
    'Fit condition for work, i.e., no signs of fatigue, alcohol, or drugs',
    'Attend all site inductions/briefings',
    'Comply with all site requirements, e.g., PPE, Traffic Management Plans (TMP)',
    'Only carry out work related to the contract',
    'Inspect completed work and report possible safety, environmental and quality matters to the Supervisor',
  ];

  const [selectedWorkerDutiesItems, setSelectedWorkerDutiesItems] = useState<
    any[]
  >(['', '', '', '', '']);
  const monitorReviewItems = [
    'All persons involved in the task must have this SWMS communicated to them before work commences',
    'SWMS to be reviewed and amended if necessary, in consultation with relevant persons after any near miss or incident',
    'If additional site hazards are identified, review this SWMS, and amend control measures to suit',
    'People, including workers, contractors, and sub-contractors, affected by the revisions to this SWMS must be informed ASAP',
    'Give the principal contractor a copy of the revised SWMS',
    'The site supervisor to monitor works against the controls stated in this SWMS',
    'SWMS must be kept on-site and made available for inspection or review',
    'Keep a record of this SWMS until the job is complete or for two years if involved in a notifiable',
  ];
  const [selectedmonitorReviewItems, setSelectedmonitorReviewItems] = useState<
    any[]
  >(['', '', '', '', '', '', '', '']);
  const siteSpecificTxt = `White card  
Online induction  
Onsite induction  
Minimum PPE: Long pants, long sleeves with cross at back and front, steel capped boots, safety glasses, ear protection, gloves  
Daily toolbox talk  
EWP tickets  
Working at Heights Training  
High Risk Work Licence  
RIW card`;
  const regulationActTxt = `Work Health and Safety Act 2011
  Work Health and Safety Regulations 2017
  First Aid in the workplace code of practice 2020
  Hazardous manual tasks code of practice 2019
  Managing noise and preventing hearing loss at work code of practice 2022
  Managing the risks of falls at workplace code of practice 2019
  Managing the risks of plant in the workplace 2022
  Guide to managing the risks of Elevating Work Platforms September 2021
  Work health and safety consultation, co-ordination, and co-operation code of practice 2019
  Construction work code of practice 2019
  Safeguarding of Machinery and Plant 2009`;
  const [selectedRegulationAct, setSelectedRegulationAct] =
    useState<string>(regulationActTxt);
  const [selectedSiteSpecificText, setSelectedSiteSpecificText] =
    useState<string>(siteSpecificTxt);
  const itemChange = (index: any, type: string) => {
    if (type === 'hazardItem') {
      setSelectedhazardousWorkItems((prev) => {
        const updated = [...prev];
        updated[index] = updated[index] === '1' ? '0' : '1'; // toggle 0 <-> 1
        return updated;
      });
    }
    if (type === 'highriskItem') {
      setSelectedhighRiskConstructionWorkItems((prev) => {
        const updated = [...prev];
        updated[index] = updated[index] === '1' ? '0' : '1'; // toggle 0 <-> 1
        return updated;
      });
    }
    if (type === 'ppeItem') {
      setSelectedPPEItems((prev) => {
        const updated = [...prev];
        updated[index] = updated[index] === '1' ? '0' : '1'; // toggle 0 <-> 1
        return updated;
      });
    }
  };
  const handleSelectChange = (value: string, index: any, type: string) => {
    if (type === 'planning') {
      setSelectedPlanning((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    }
    if (type === 'holdpoint') {
      setSelectedHoldPointsItems((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    }

    if (type === 'training') {
      setSelectedTrainingLicenceItems((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    }

    if (type === 'workduties') {
      setSelectedWorkerDutiesItems((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    }
    if (type === 'monitor') {
      setSelectedmonitorReviewItems((prev) => {
        const updated = [...prev];
        updated[index] = value;
        return updated;
      });
    }
  };
  const handleInputChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    type: any
  ) => {
    const { name, value } = e.target;
    if (type === 'RegulationAct') {
      setSelectedRegulationAct(e.target.value);
    }
    if (type === 'siteSpecific') {
      setSelectedSiteSpecificText(e.target.value);
    }
    // setForm((prevData) => ({
    //   ...prevData,
    //   [name]: { ...prevData[name], value: value },
    // }));
  };
  const handleFormInputChange = (e: React.ChangeEvent<any>) => {
    const { name, value } = e.target;
    console.log(value + '-------' + name);
    setForm((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleFormDateChange = (value: any, name: any) => {
    console.log(value + '-------' + name);
    setForm((prevData: any) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleSave = async () => {
    // console.log(form);
    // console.log(selectedhazardousWorkItems);
    // console.log(selectedhighRiskConstructionWorkItems);
    // console.log(selectedPPEItems);
    // console.log(selectedPlanning);
    // console.log(selectedHoldPointsItems);
    // console.log(selectedWorkerDutiesItems);
    // console.log(selectedTrainingLicenceItems);
    // console.log(selectedmonitorReviewItems);
    // console.log(selectedSiteSpecificText);
    // console.log(selectedRegulationAct);
    setInProgress(true);
    const reqData: any = {
      workActivity: form.workActivity,
      siteOwner: form.siteOwner,
      developedBy: form.developedBy,
      approvedBy: form.approvedBy,
      datePrepared: form.datePrepared,
      revisionDate: form.revisionDate,
      items: [
        {
          title: 'hazardousWork',
          value: selectedhazardousWorkItems.join(','),
        },
        {
          title: 'highRiskConstructionWork',
          value: selectedhighRiskConstructionWorkItems.join(','),
        },
        {
          title: 'protections',
          value: selectedPPEItems.join(','),
        },
        {
          title: 'plannings',
          value: selectedPlanning.join(','),
        },
        {
          title: 'holdPoint',
          value: selectedHoldPointsItems.join(','),
        },
        {
          title: 'trainings',
          value: selectedTrainingLicenceItems.join(','),
        },
        {
          title: 'workerDuties',
          value: selectedWorkerDutiesItems.join(','),
        },
        {
          title: 'monitors',
          value: selectedmonitorReviewItems.join(','),
        },
        {
          title: 'siteSpecificRequirements',
          value: selectedSiteSpecificText,
        },
        {
          title: 'actRegulations',
          value: selectedRegulationAct,
        },
      ],
    };

    const endpoint = `${Constants.apiURL + Constants.projectDashboardsURL}/${projectInternalId}/swmsdetails`;
    let response: any;
    try {
      response = await HttpServices.post(endpoint, reqData, {
        headers: { Authorization: `Bearer ${getAdmin()}` },
      });

      if (response.success) {
        await fetchSingleRecord();
        setAlert({
          type: 'success',
          message: 'Success',
          open: true,
        });
      }
    } catch (error: any) {
      console.error(`GET ERROR:`, error);
      setAlert({
        type: 'error',
        message: handleErrorMessage(error),
        open: true,
      });
    } finally {
      setInProgress(false);
    }
  };
  const handleRowClick = (record: any) => {
    setForm({
      workActivity: record.workActivity,
      siteOwner: record.siteOwner,
      developedBy: record.developedBy,
      approvedBy: record.approvedBy,
      datePrepared: record.datePrepared,
      revisionDate: record.revisionDate,
    });
    if (record.items.length > 0) {
      const hazards = record.items.find(
        (item: any) => item.title === 'hazardousWork'
      );
      const highriskItems = record.items.find(
        (item: any) => item.title === 'highRiskConstructionWork'
      );

      const protections = record.items.find(
        (item: any) => item.title === 'protections'
      );

      const plannings = record.items.find(
        (item: any) => item.title === 'plannings'
      );
      const holdPoint = record.items.find(
        (item: any) => item.title === 'holdPoint'
      );
      const trainings = record.items.find(
        (item: any) => item.title === 'trainings'
      );
      const workerDuties = record.items.find(
        (item: any) => item.title === 'workerDuties'
      );
      const monitors = record.items.find(
        (item: any) => item.title === 'monitors'
      );
      const siteSpecificRequirements = record.items.find(
        (item: any) => item.title === 'siteSpecificRequirements'
      );
      const actRegulationsData = record.items.find(
        (item: any) => item.title === 'actRegulations'
      );
      if (hazards) setSelectedhazardousWorkItems(hazards.value.split(','));
      if (highriskItems)
        setSelectedhighRiskConstructionWorkItems(
          highriskItems.value.split(',')
        );
      if (protections) setSelectedPPEItems(protections.value.split(','));
      if (plannings) setSelectedPlanning(plannings.value.split(','));
      if (holdPoint) setSelectedHoldPointsItems(holdPoint.value.split(','));
      if (trainings)
        setSelectedTrainingLicenceItems(trainings.value.split(','));
      if (workerDuties)
        setSelectedWorkerDutiesItems(workerDuties.value.split(','));
      if (monitors) setSelectedmonitorReviewItems(monitors.value.split(','));

      if (siteSpecificRequirements) {
        setSelectedSiteSpecificText(siteSpecificRequirements.value);
      }
      if (actRegulationsData) {
        setSelectedRegulationAct(actRegulationsData.value);
      }
    }
  };
  return (
    <Box sx={{ padding: ' 16px' }} className="mt-4">
      {isLoading && <LinearProgress />}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography component={'h3'} className="projectItemMainTitle">
          Details
        </Typography>
        <Button
          style={{
            textDecoration: 'none',
            textTransform: 'capitalize',
            color: 'rgba(0, 244, 255, 1)',
            background: 'rgb(1, 1, 1)',
            marginLeft: 3,
          }}
          variant="contained"
          disabled={inProgress}
          onClick={handleSave}
        >
          {inProgress ? 'Saving...!' : 'Save'}
        </Button>
      </Box>
      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
        }}
      >
        <Typography component={'h3'} className="projectItemSubTitleB">
          Safe work method Statement (SWMS)
        </Typography>
        <Grid container spacing={2}>
          <Grid size={4}>
            <TextFieldComponent
              label={'Work Activity'}
              keyName={'workActivity'}
              name={'workActivity'}
              value={form.workActivity}
              onChange={handleFormInputChange}
              errorStr={''}
              isRequired={false}
            />
          </Grid>
          <Grid size={4}>
            <TextFieldComponent
              label={'Site Owner/Principal Contractor'}
              keyName={'siteOwner'}
              name={'siteOwner'}
              value={form.siteOwner}
              onChange={handleFormInputChange}
              errorStr={''}
              isRequired={false}
            />
          </Grid>
          <Grid size={4}>
            <SelectFieldComponent
              label={'Developed By'}
              isRequired={false}
              items={usersList}
              keyName={'developedby'}
              name={'developedby'}
              value={form.developedBy}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, developedBy: e.target.value }))
              }
              errorStr={''}
            />
          </Grid>
          <Grid size={4}>
            <SelectFieldComponent
              label={'Approved By'}
              isRequired={false}
              items={usersList}
              keyName={'approvedBy'}
              name={'approvedBy'}
              value={form.approvedBy}
              onChange={(e) =>
                setForm((prev) => ({ ...prev, approvedBy: e.target.value }))
              }
              errorStr={''}
            />
          </Grid>
          <Grid size={4}>
            <DatePickerComponent
              name={'datePrepared'}
              label={'Date Prepared'}
              defaultValue={form.datePrepared}
              onChange={(dateValue: any) => {
                handleFormDateChange(dateValue, 'datePrepared');
              }}
              isRequired={false}
              keyName={'datePrepared'}
              errorStr={''}
            />
          </Grid>
          <Grid size={4}>
            <DatePickerComponent
              name={'revisionDate'}
              label={'Revision Date'}
              defaultValue={form.revisionDate}
              onChange={(dateValue: any) => {
                handleFormDateChange(dateValue, 'revisionDate');
              }}
              isRequired={false}
              keyName={'revisionDate'}
              errorStr={''}
            />
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
          mt: 3,
        }}
      >
        <Typography component={'h3'} className="projectItemSubTitleB">
          This work activity involves the following hazardous work and
          environmental impacts
        </Typography>
        <Grid container spacing={2}>
          {hazardousWorkItems.map((itemHazard: any, index: number) => {
            return (
              <Grid size={3}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={selectedhazardousWorkItems[index] === '1'}
                        onChange={(event) => {
                          itemChange(index, 'hazardItem');
                        }}
                      />
                    }
                    label={itemHazard}
                  />
                </FormGroup>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
          mt: 3,
        }}
      >
        <Typography component={'h3'} className="projectItemSubTitleB">
          This work activity involves the following "HIGH-RISK CONSTRUCTION
          WORK"
        </Typography>
        <Grid container spacing={2}>
          {highRiskConstructionWorkItems.map((itemRisk: any, index: number) => {
            return (
              <Grid size={4}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={
                          selectedhighRiskConstructionWorkItems[index] === '1'
                        }
                        onChange={(event) => {
                          itemChange(index, 'highriskItem');
                        }}
                      />
                    }
                    label={itemRisk}
                  />
                </FormGroup>
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
          mt: 3,
        }}
      >
        <Grid container spacing={2}>
          {ppeItems.map((ppeItemData: any, index: number) => {
            return (
              <Grid size={2}>
                <IconItem
                  label={ppeItemData}
                  isSelected={selectedPPEItems[index] === '1'}
                  onClick={() => {
                    itemChange(index, 'ppeItem');
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      </Box>
      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
          mt: 3,
        }}
      >
        <Typography component={'h3'} className="projectItemMainTitle">
          Item / Action
        </Typography>
        <Box>
          <Typography component={'h3'} className="projectItemSubTitleB">
            Planning/Preparation
          </Typography>
          <Grid container spacing={2}>
            {planningPreparationItems.map((ppItem: any, index: number) => {
              return (
                <Grid size={6}>
                  <Typography component={'h3'} className="dropdownlabel">
                    {ppItem}
                  </Typography>
                  <SelectFieldComponent
                    label={''}
                    keyName={'planning_' + index}
                    name={'planning_' + index}
                    value={selectedPlanning[index]}
                    onChange={(e: any) => {
                      handleSelectChange(e.target.value, index, 'planning');
                    }}
                    errorStr={''}
                    isRequired={false}
                    items={dropDownValues}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box>
          <Typography component={'h3'} className="projectItemSubTitleB">
            Hold Points
          </Typography>
          <Grid container spacing={2}>
            {holdPointsItems.map((HItem: any, index: number) => {
              return (
                <Grid size={6}>
                  <Typography component={'h3'} className="dropdownlabel">
                    {HItem}
                  </Typography>
                  <SelectFieldComponent
                    label={''}
                    keyName={'holdpoint_' + index}
                    name={'holdpoint_' + index}
                    value={selectedHoldPointsItems[index]}
                    onChange={(e: any) => {
                      handleSelectChange(e.target.value, index, 'holdpoint');
                    }}
                    errorStr={''}
                    isRequired={false}
                    items={dropDownValues}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box>
          <Typography component={'h3'} className="projectItemSubTitleB">
            Training/Licence
          </Typography>
          <Grid container spacing={2}>
            {trainingLicenceItems.map((TItem: any, index: number) => {
              return (
                <Grid size={6}>
                  <Typography component={'h3'} className="dropdownlabel">
                    {TItem}
                  </Typography>
                  <SelectFieldComponent
                    label={''}
                    keyName={'training_' + index}
                    name={'training_' + index}
                    value={selectedTrainingLicenceItems[index]}
                    onChange={(e: any) => {
                      handleSelectChange(e.target.value, index, 'training');
                    }}
                    errorStr={''}
                    isRequired={false}
                    items={dropDownValues}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box>
          <Typography component={'h3'} className="projectItemSubTitleB">
            Work duties and responsiblities
          </Typography>
          <Grid container spacing={2}>
            {workerDutiesItems.map((WItem: any, index: number) => {
              return (
                <Grid size={6}>
                  <Typography component={'h3'} className="dropdownlabel">
                    {WItem}
                  </Typography>
                  <SelectFieldComponent
                    label={''}
                    keyName={'workduties_' + index}
                    name={'workduties_' + index}
                    value={selectedWorkerDutiesItems[index]}
                    onChange={(e: any) => {
                      handleSelectChange(e.target.value, index, 'workduties');
                    }}
                    errorStr={''}
                    isRequired={false}
                    items={dropDownValues}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
        <Box>
          <Typography component={'h3'} className="projectItemSubTitleB">
            Monitor/Review
          </Typography>
          <Grid container spacing={2}>
            {monitorReviewItems.map((WItem: any, index: number) => {
              return (
                <Grid size={6}>
                  <Typography component={'h3'} className="dropdownlabel">
                    {WItem}
                  </Typography>
                  <SelectFieldComponent
                    label={''}
                    keyName={'monitor_' + index}
                    name={'monitor_' + index}
                    value={selectedmonitorReviewItems[index]}
                    onChange={(e: any) => {
                      handleSelectChange(e.target.value, index, 'monitor');
                    }}
                    errorStr={''}
                    isRequired={false}
                    items={dropDownValues}
                  />
                </Grid>
              );
            })}
          </Grid>
        </Box>
      </Box>

      <Box
        sx={{
          backgroundColor: '#FFF',
          border: '1px solid #EFEEED',
          borderRadius: '6px',
          padding: ' 16px',
          mt: 3,
        }}
      >
        <Typography component={'h3'} className="projectItemSubTitleB">
          Regardless of any other factor, the person in control of the workplace
          must review this SWMS atleast annually.
        </Typography>
        <Grid container spacing={2}>
          <Grid size={6} sx={{ position: 'relative' }}>
            <IconButton
              type="button"
              sx={{ position: 'absolute', right: '0px', top: '-10px' }}
              onClick={() => {
                setSelectedSiteSpecificText(siteSpecificTxt);
              }}
            >
              <Refresh />
            </IconButton>
            <TextFieldAreaComponent
              onChange={(e: any) => {
                handleInputChange(e, 'siteSpecific');
              }}
              label={'Site-Specific Requirements'}
              isRequired={false}
              value={selectedSiteSpecificText}
              keyName={'SiteSpecificText'}
              name={'SiteSpecificText'}
              errorStr={''}
              minRows={14}
            />
          </Grid>
          <Grid size={6} sx={{ position: 'relative' }}>
            <IconButton
              type="button"
              sx={{ position: 'absolute', right: '0px', top: '-10px' }}
              onClick={() => {
                setSelectedRegulationAct(regulationActTxt);
              }}
            >
              <Refresh />
            </IconButton>
            <TextFieldAreaComponent
              onChange={(e: any) => {
                handleInputChange(e, 'RegulationAct');
              }}
              label={'Act, Regulations, Codes of Practice References:'}
              isRequired={false}
              value={selectedRegulationAct}
              keyName={'RegulationAct'}
              name={'RegulationAct'}
              errorStr={''}
              minRows={14}
            />
          </Grid>
        </Grid>
      </Box>
      <AlertMessageComponent
        type={alert.type}
        open={alert.open}
        handleClose={handleCloseAlert}
        message={alert.message}
      />
    </Box>
  );
};
export default SWMSDetails;
